import { Locale, formatMessage } from "backend/src/common/i18n";

export const getPlayerDisplayName = (
  locale: Locale,
  name?: string | null,
): string => {
  return name || formatMessage(locale, "player.unnamed");
};
